interface EmailTabProps {
  values: Record<string, string>;
  onUpdate: (key: string, value: string) => void;
}

export default function EmailTab({ values, onUpdate }: EmailTabProps) {
  const base = "w-full rounded-lg border border-background-300 bg-background-50 px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-primary-400";

  const toggles = [
    { key: "notify_new_lead", label: "New lead submitted", desc: "Send an email when a new enquiry comes in." },
    { key: "notify_new_deal", label: "New deal created", desc: "Send an email when a deal is added." },
    { key: "notify_property_approved", label: "Project approved", desc: "Send an email when a project status changes to active." },
    { key: "notify_daily_summary", label: "Daily summary", desc: "Send a daily digest of leads and activities." },
  ];

  return (
    <div className="space-y-5">
      <div className="rounded-2xl bg-background-50 border border-background-200 overflow-hidden">
        <div className="px-5 py-4 border-b border-background-100">
          <div className="flex items-center gap-3">
            <span className="flex items-center justify-center w-9 h-9 rounded-xl bg-secondary-100 text-secondary-700">
              <i className="ri-mail-settings-line"></i>
            </span>
            <div>
              <h3 className="font-heading text-base text-foreground-950">Email Notifications</h3>
              <p className="text-xs text-foreground-600">Choose which events trigger email alerts to admins.</p>
            </div>
          </div>
        </div>
        <div className="p-5 space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-semibold text-foreground-800 mb-1.5">Notification email</label>
              <input
                className={base}
                value={values.notification_email || ""}
                onChange={(e) => onUpdate("notification_email", e.target.value)}
                placeholder="admin@nomadlivings.com"
              />
            </div>
            <div>
              <label className="block text-xs font-semibold text-foreground-800 mb-1.5">Sender name</label>
              <input
                className={base}
                value={values.email_sender_name || ""}
                onChange={(e) => onUpdate("email_sender_name", e.target.value)}
                placeholder="NOMADLIVINGS"
              />
            </div>
          </div>

          <div className="space-y-3 pt-2">
            {toggles.map((t) => {
              const on = values[t.key] === "1" || values[t.key] === "true";
              return (
                <div
                  key={t.key}
                  className="flex items-center justify-between rounded-xl bg-background-100 border border-background-200 p-4"
                >
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{t.label}</p>
                    <p className="text-xs text-foreground-600">{t.desc}</p>
                  </div>
                  <button
                    type="button"
                    onClick={() => onUpdate(t.key, on ? "0" : "1")}
                    className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
                      on ? "bg-primary-600" : "bg-background-300"
                    }`}
                  >
                    <span
                      className={`inline-block h-4 w-4 transform rounded-full bg-background-50 transition-transform ${
                        on ? "translate-x-6" : "translate-x-1"
                      }`}
                    />
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}